import { render } from "./AppToolbarOld.vue?vue&type=template&id=f4e4b182"
import script from "./AppToolbarOld.vue?vue&type=script&lang=js"
export * from "./AppToolbarOld.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/goatsd.com_VUE.js_main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__